import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function FlashcardSkeleton() {
  return (
    <Card className="flex w-full h-full min-h-0 flex-col overflow-hidden bg-primary-background pt-2 sm:pt-5 sm:mx-auto sm:max-w-sm sm:rounded-2xl sm:h-fit sm:shadow-lg">
      {/* 헤더 스켈레톤 */}
      <CardHeader className="flex items-center justify-between px-5">
        <Skeleton className="size-8 rounded-lg" />
        <Skeleton className="h-5 w-13" />
        <Skeleton className="size-8 rounded-lg" />
      </CardHeader>

      {/* 카운트 배지 스켈레톤 */}
      <div className="flex justify-between gap-4 px-5">
        <Skeleton className="h-8 w-15.5 rounded-lg" />
        <Skeleton className="h-8 w-15.5 rounded-lg" />
      </div>

      {/* 카드 스켈레톤 */}
      <CardContent className="flex flex-1 min-h-0 items-center justify-center px-5 sm:aspect-3/4 sm:max-h-fit">
        <Skeleton className="w-full h-full rounded-2xl" />
      </CardContent>

      {/* 푸터 스켈레톤 */}
      <CardFooter className="flex items-center justify-between gap-2 border-t-0 p-6 pt-0 bg-transparent">
        <Skeleton className="size-12 rounded-xl" />
        <Skeleton className="size-12 rounded-xl" />
      </CardFooter>
    </Card>
  );
}
